/**
 * Joins class names, dropping anything falsy. Four lines instead of `clsx`, because a dependency
 * whose whole job is `filter(Boolean).join(' ')` is a dependency to audit, update and ship.
 *
 * `false | null | undefined` rather than `boolean`: `cx(a, cond && b)` is the only shape used, and
 * allowing a bare `true` would silently print `"true"` as a class name.
 */
export function cx(...parts: readonly (string | false | null | undefined)[]): string {
  return parts.filter((part): part is string => typeof part === 'string' && part !== '').join(' ');
}
